import Tone from 'tone';
import {
    getYPositionFromValue,
    getYForParameter,
    getXPositionFromStep,
    getStepFromXPosition,
    getValueFromYPosition
} from './position.js';

export const getGuidePoint = (automation, step, selectedParameter, height) => {
    if (automation.automations.length === 0) {
        let value = selectedParameter.toFrequency ?
            selectedParameter.toFrequency() :
            selectedParameter.get();
        if (selectedParameter.getNumberFromOption) {
            value = selectedParameter.getNumberFromOption(value);
        }
        return {
            step,
            value
        };
    }
    let point = automation.getClosestBefore(step);
    if (point === undefined) {
        // theres none before (so its the first)
        return {
            step: step,
            value: automation.automations[0].value
        };
    }

    let nextEvent = automation.getNextEvent(point);
    if (nextEvent === undefined) {
        return {
            step: step,
            value: automation.automations[automation.automations.length - 1].value
        };
    }
    let distance = nextEvent.step - point.step;
    let innerDistance = step - point.step;
    let {min, max} = selectedParameter;
    let nextY = getYPositionFromValue(nextEvent.value, height, min, max);
    let currentY = getYPositionFromValue(point.value, height, min, max);
    let slope = (nextY - currentY) / (nextEvent.step - point.step);
    let position = currentY + innerDistance * slope;
    return {
         step,
        value: getValueFromYPosition(position, height, min, max)
    };
}
